module.exports = __webpack_public_path__ + "img/download.9dd3eb1.svg";